var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.52,
    height: 17.52,
    viewBox: "0 0 17.52 17.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-total-879221",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3869",
    "data-name": "Rectangle 3869",
    width: 6.708,
    height: 0.437,
    transform: "translate(5.156 6.587)",
    fill: "#e47755",
    stroke: "#e47755",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3870",
    "data-name": "Rectangle 3870",
    width: 6.708,
    height: 0.437,
    transform: "translate(5.156 10.045)",
    fill: "#e47755",
    stroke: "#e47755",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9631",
    "data-name": "Path 9631",
    d: "M18.972,10.4a8.51,8.51,0,1,0,8.508,8.509A8.51,8.51,0,0,0,18.972,10.4Zm0,16.576a8.071,8.071,0,1,1,8.069-8.066,8.071,8.071,0,0,1-8.069,8.066Z",
    transform: "translate(-10.46 -10.4)",
    fill: "#e47755",
    stroke: "#e47755",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProjectIcon);
export default __webpack_public_path__ + "static/media/total-project-icon.82bd0b7bb7ab56758707387a099fc302.svg";
export { ForwardRef as ReactComponent };